import type { PlacementPose } from "@/runtime/types";

export interface PlacementStabilityOptions {
  holdMs: number;
  maxJumpMeters: number;
}

const DEFAULT_OPTIONS: PlacementStabilityOptions = { holdMs: 500, maxJumpMeters: 0.05 };

export class PlacementStabilityGate {
  private startedAt: number | null = null;
  private previous: PlacementPose | null = null;

  constructor(private readonly options: PlacementStabilityOptions = DEFAULT_OPTIONS) {}

  observe(pose: PlacementPose | null, now: number): { progress: number; accepted: PlacementPose | null } {
    if (!pose) {
      this.reset();
      return { progress: 0, accepted: null };
    }

    if (!this.previous || distance(this.previous.position, pose.position) > this.options.maxJumpMeters) {
      this.startedAt = now;
    }

    this.previous = pose;
    this.startedAt ??= now;
    const progress = Math.min(1, Math.max(0, (now - this.startedAt) / this.options.holdMs));
    return { progress, accepted: progress >= 1 ? pose : null };
  }

  reset(): void {
    this.startedAt = null;
    this.previous = null;
  }
}

function distance(a: PlacementPose["position"], b: PlacementPose["position"]): number {
  return Math.hypot(a[0] - b[0], a[1] - b[1], a[2] - b[2]);
}
